import { Form } from 'antd';
import { t } from 'i18next';

import FormattedTextInput from '@/components/general/FormattedTextInput';
import { FormSubsection } from '@/components/general/FormSection';
import UploadedFileCarousel from '@/components/general/UploadFile/UploadedFileCarousel';
import UploadFileComponent from '@/components/general/UploadFile/UploadFile';
import FileData from '@/model/General/FileData';

interface TicketFormDescriptionProps {
  fileList: FileData[];
  setFileList: (files: FileData[]) => void;
}

const TicketFormDescription = (props: TicketFormDescriptionProps) => {
  const { fileList, setFileList } = props;

  return (
    <FormSubsection title={t('Detalle del ticket')} style={{ margin: '24px 0 12px' }}>
      <Form.Item label={t('Descripción')} name={'description'}>
        <FormattedTextInput readOnly={false} />
      </Form.Item>
      <Form.Item label={t('Archivos')}>
        <UploadFileComponent fileList={fileList} setFileList={setFileList} />
      </Form.Item>
      {fileList.length > 0 && (
        <Form.Item label={t('Archivos subidos')}>
          <UploadedFileCarousel fileList={fileList} setFileList={setFileList} />
        </Form.Item>
      )}
    </FormSubsection>
  );
};

export default TicketFormDescription;
